import styled from "styled-components";
import React from "react";
import {Bookmark, Home, MessageCircle, Paperclip, Send, Star} from "react-feather";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-scroll";

export const ContainerMenu = styled.footer`
    position: fixed;
    height: 110px;
    width: 100%;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-items: flex-end;
    justify-content: flex-end;
    align-items: flex-end;
    
`;

export const WrapperMenu = styled.footer`
    display: flex;
    height: 80px;
    background: #21465E;
    width: 100%;
    border-radius: 15px 15px 0px 0px;
    color: white;
    text-align: center;
    justify-items: center;
    justify-content: space-around;
    align-items: center;
    
    
`;

export const ContainerBotao = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 9px;
    height: 70px;
    width: 100%;
    color: white;
    text-align: center;
    margin: 2px;
    justify-items: center;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    opacity: 0.7;
   
   
    div{
         letter-spacing: -0.3px;
         margin: 5px;
         margin-top: 3px;
    }
    span{
    font-size: 20px;
    }
    
    
     :hover {
       opacity: 1;
       transform: scale(1.1);
    }
`;


export const Badeg = styled.div`
    position: absolute;
    display: flex;
    width: 50px;
    height: 50px;
    margin: 0 auto;
    left: 0;
    right: 0;
    top: 0px;
    background: #21465E;
    border-radius: 50%;
   
    
    box-shadow: 2px 2px 15px 2px rgba(0,0,0,0.50);
    justify-content: center;
    align-items: center;
    div{
    color: white;
    opacity: 0.5;
     :hover {
       opacity: 1;
       transform: scale(1.1);
    }
    }
`;


const CardBtn = ({icon, texto, to}) => {
    return (
        <Link
            to={to}
            activeClass="active"
            spy={true}
            smooth={true}
            offset={0}
            duration={500}
        >
            <ContainerBotao>
                {icon}
                <div>{texto}</div>
            </ContainerBotao>
        </Link>
    )
};


export const MenuBotton = () => {
    return (
        <ContainerMenu>
            <Badeg>
                <Link
                    to={'home'}
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                >
                    <div><Home/></div>
                </Link>
            </Badeg>
            <WrapperMenu>
                <CardBtn icon={<Bookmark/>}
                         texto={'PROSPECÇÃO'}
                         to={'prospeccao'}
                />
                <CardBtn
                    icon={<Paperclip/>}
                    texto={'PROPOSTA'}
                    to={'proposta'}
                />

                <CardBtn
                    icon={<span><FontAwesomeIcon icon={"gavel"} color="#00000"/></span>}
                    texto={'LICITAÇÕES'}
                    to={'licitacoes'}
                />

                <CardBtn
                    icon={<Send/>}
                    texto={'LANCES'}
                    to={'lances'}
                />

                <CardBtn icon={<MessageCircle/>} texto={'MONITORAR'} to={'monitoramento'}/>

            </WrapperMenu>
        </ContainerMenu>
    )
}